import React from 'react'
import { Helmet } from 'react-helmet'
import { Link, graphql } from 'gatsby'
import get from 'lodash/get'

import Seo from '../components/seo'
import Layout from '../components/layout'
import Hero from '../components/hero'
import ArticleBody from '../components/article-body'
import Tags from '../components/tags'
import * as styles from './blog-post.module.css'
import * as styles2 from './blog-post.module2.css'

class BlogPostTemplate extends React.Component {
  render() {
    const post = get(this.props, 'data.contentfulBlogPost')
    const previous = get(this.props, 'data.previous')
    const next = get(this.props, 'data.next')
    const siteUrl = get(this.props, 'data.site.siteMetadata.siteUrl', '')
    const siteName = get(this.props, 'data.site.siteMetadata.siteName', 'レジャーWave！')
    const pathname = '/blog/' + post.slug + '/'
    const image = post.heroImage?.resize?.src ? 'https:' + post.heroImage.resize.src : undefined
    const description = post.description?.childMarkdownRemark?.excerpt
    const pageUrl = siteUrl ? siteUrl.replace(/\/$/, '') + pathname : pathname
    const jsonLd = {
      '@context': 'https://schema.org',
      '@type': 'BlogPosting',
      headline: post.title,
      description,
      image,
      datePublished: post.rawDate,
      author: {
        '@type': 'Person',
        name: post.author.name,
      },
      publisher: {
        '@type': 'Organization',
        name: siteName,
      },
      mainEntityOfPage: {
        '@type': 'WebPage',
        '@id': pageUrl,
      },
    }

    return (
      <Layout location={this.props.location}>
        <Seo
          title={post.title}
          description={description}
          image={image}
          pathname={pathname}
          article
        >
          <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
        </Seo>
        <Hero
          image={post.heroImage.gatsbyImageData}
          title={post.title}
          content={description}
        />
        <div className={styles.container}>
        <Helmet>
          <script type="text/javascript" language="javascript">
            {`
              var vc_pid = "890748555";
            `}
          </script>
          <script
            type="text/javascript"
            src="//aml.valuecommerce.com/vcdal.js"
            async
          />
        </Helmet>
          <div className={styles2}>
          <div className={styles.article}>
            <div className={styles.body}>
              <ArticleBody html={post.body.childMarkdownRemark.html} />
            </div>
            <Tags tags={post.tags} />
            {(previous || next) && (
              <nav>
                <ul className={styles.articleNavigation}>
                  {previous && (
                    <li>
                      <Link to={'/blog/' + previous.slug + '/'} rel="prev">
                        &larr; {previous.title}
                      </Link>
                    </li>
                  )}
                  {next && (
                    <li>
                      <Link to={'/blog/' + next.slug + '/'} rel="next">
                        {next.title} &rarr;
                      </Link>
                    </li>
                  )}
                </ul>
              </nav>
            )}
          </div>

        </div>
        </div>
      </Layout>
    )
  }
}

export default BlogPostTemplate

export const pageQuery = graphql`
  query BlogPostBySlug(
    $slug: String!
    $previousPostSlug: String
    $nextPostSlug: String
  ) {
    contentfulBlogPost(slug: { eq: $slug }) {
      slug
      title
      author {
        name
      }
      rawDate: publishDate
      heroImage {
        gatsbyImageData(layout: FULL_WIDTH, placeholder: BLURRED, width: 1280)
        resize(height: 630, width: 1200) {
          src
        }
      }
      body {
        childMarkdownRemark {
          html
        }
      }
      tags
      description {
        childMarkdownRemark {
          excerpt
        }
      }
    }
    site {
      siteMetadata {
        siteUrl
        siteName
      }
    }
    previous: contentfulBlogPost(slug: { eq: $previousPostSlug }) {
      slug
      title
    }
    next: contentfulBlogPost(slug: { eq: $nextPostSlug }) {
      slug
      title
    }
  }
`
